"use client";

import { useEffect } from "react";
import {
  completeSynapticAuthCallback,
} from "@/lib/auth";

export default function AuthCallbackPage() {
  useEffect(() => {
    const result = completeSynapticAuthCallback(
      window.location.href,
      window.localStorage,
    );

    window.dispatchEvent(new Event("synaptic-auth:changed"));
    window.location.replace(result.next);
  }, []);

  return (
    <main className="grid min-h-screen place-items-center bg-background px-4 text-center">
      <div>
        <p className="text-sm uppercase tracking-[0.2em] text-muted-foreground">Synaptic Identity</p>
        <h1 className="mt-3 text-2xl font-semibold">Completing authentication</h1>
      </div>
    </main>
  );
}
